import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { animated, useSpring } from "react-spring";
import { tesaBlue, tesaRed } from "../../styles/colors";

interface CustomFooterGraphicProps {
  hasMargin?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(10),
    },
    hasMargin: {
      marginLeft: theme.spacing(7),
      marginRight: theme.spacing(7),
    },
    left: {
      borderBottom: `3px solid ${tesaRed}`,
      marginRight: "3px",
      width: "75%",
    },
    right: {
      borderBottom: `3px solid ${tesaBlue}`,
      width: "25%",
    },
  }),
);

const CustomFooterGraphic = (props: CustomFooterGraphicProps) => {
  const classes = useStyles(props);
  const { hasMargin } = props;

  const springProps = useSpring({
    from: { opacity: 0, width: "0%" },
    to: { opacity: 1, width: "100%" },
  });

  return (
    <animated.div className={[classes.root, hasMargin ? classes.hasMargin : null].join(" ")} style={springProps}>
      <div className={classes.left} />
      <div className={classes.right} />
    </animated.div>
  );
};

export default CustomFooterGraphic;
